import { AlertCircle, AlertTriangle, Inbox, Info, type LucideIcon } from "lucide-react";
import type { ReactElement } from "react";

export type FeedbackVariant = "error" | "warning" | "info" | "empty";

/** Shared status icons — use for toasts, feedback cards, and inline alerts. */
export const FEEDBACK_ICONS: Record<FeedbackVariant, LucideIcon> = {
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info,
  empty: Inbox,
};

export function FeedbackStatusIcon({
  variant,
  className,
}: {
  variant: FeedbackVariant;
  className?: string;
}): ReactElement {
  const Icon = FEEDBACK_ICONS[variant];
  return <Icon className={className} aria-hidden />;
}
